export default {
  firestorePort: 4001,
  functionsUrl: `http://localhost:3000/functions`,
  hostingUrl: `http://localhost:3000`,
}
